import React, { useState, useEffect } from 'react';
import { withStyles, ThemeProvider, makeStyles } from '@material-ui/core/styles';
import { Grid, Button, Dialog, TextField, Switch, FormGroup, FormControlLabel, InputLabel, MenuItem, FormControl, Select } from '@material-ui/core';
import MuiDialogTitle from '@material-ui/core/DialogTitle';
import MuiDialogContent from '@material-ui/core/DialogContent';
import MuiDialogActions from '@material-ui/core/DialogActions';
import Typography from '@material-ui/core/Typography';
import { lightTheme } from "../../SharedComponents/SharedComponentStyles";
import "../../SharedComponents/Elements/ToggleSwitch/ToggleSwitch.css";
import axios from 'axios'
import Input from '@material-ui/core/Input';
import ListItemText from '@material-ui/core/ListItemText';
import Checkbox from '@material-ui/core/Checkbox';
import CircularProgress from '@material-ui/core/CircularProgress';
//Autocomplete
import Autocomplete from '@material-ui/lab/Autocomplete';
import { useSelector, useDispatch } from "react-redux";

const api = axios.create({
    baseURL: 'MasterDetails'
})

const apiSlip = axios.create({
    baseURL: 'SlipGeneration'
})

const styles = (theme) => ({
    root: {
        margin: 0,
        padding: theme.spacing(2),
    },
    closeButton: {
        position: 'absolute',
        right: theme.spacing(1),
        top: theme.spacing(1),
        color: theme.palette.grey[500],
    },
    
    selectEmpty: {
        marginTop: theme.spacing(2),
    },
});

const useStyles = makeStyles((theme) => ({
    root: {
        flexGrow: 1,
    },
    myComponent: {
        "& .MuiSvgIcon-root": {
            background: `var(--red) !important`
        }
    }
}));

const DialogTitle = withStyles(styles)((props) => {
    const { children, classes, onClose, ...other } = props;
    return (
        <MuiDialogTitle disableTypography className={classes.root} {...other}>
            <Typography variant="h6">{children}</Typography>
        </MuiDialogTitle>
    );
});

const DialogContent = withStyles((theme) => ({
    root: {

    },
}))(MuiDialogContent);

const DialogActions = withStyles((theme) => ({
    root: {
    },
}))(MuiDialogActions);

const GrantAccessSwitch = withStyles({
    switchBase: {
        color: `var(--toggle-switch-color)`,
        '&$checked': {
            color: `var(--toggle-switch-checked-color)`,
        },
        '&$checked + $track': {
            backgroundColor: `var(--toggle-switch-bg-color)`,
        },
    },
    checked: {},
    track: {},
})(Switch);

export default function RegistrationForm(props) {
    //for progress
    const [openLoader, setopenLoader] = useState(false);
    const token = useSelector((state) => state.saveAzureTokenReducer.token);
    const userDetails = useSelector(
    (state) => state.storeUserDetailsReducer.userData);
    const bearerToken = useSelector(
    (state) => state.saveBearerTokenReducer.bearerToken);
    const uId = useSelector((state) => state.saveUIDReducer.uid);
    const [operationSaveValue, setoperationSaveValue] = useState("");
    const [operationIdValue, setoperationIdValue] = useState([]);
    const [operationNameValue, setoperationNameValue] = useState([]);
    const [wage, setwage] = useState([]);
    const [wageValue, setwageValue] = useState("");
    const [workCenter, setworkCenter] = useState([]);
    const [workCenterValue, setworkCenterValue] = useState("");
    const [material, setmaterial] = useState([]);
    const [materialValue, setmaterialValue] = useState([]);
    const [groupcenter, setgroupcenter] = useState([]);
    const [groupcenterValue, setgroupcenterValue] = useState([]);
    const [operation, setoperation] = useState([]);
    const [operationValue, setoperationValue] = useState([]);
    const [workingMethod, setworkingMethod] = useState([]);
    const [workingMethodValue, setworkingMethodValue] = useState(1);
    const [machineRuntime, setmachineRuntime] = useState(0);
    const [labourSetuptime, setlabourSetuptime] = useState(0);
    const [baseQuantity, setbaseQuantity] = useState(0);
    const [okpcs, setokpcs] = useState(0);
    const [notokpcs, setnotokpcs] = useState(0);
    const [noofsettings, setnoofsettings] = useState(0);
    const [addsetuptime, setaddsetuptime] = useState(0);
    const [extracost, setextracost] = useState(0);
    const [inputmin, setinputmin] = useState(0);
    const [outputmin, setoutputmin] = useState(0);
    const [slipDetId, setslipDetId] = useState(0);
    const [open, setOpen] = React.useState(false);
    const [workCenterNameValue, setWorkCenterNameValue] = useState([]);
    const [materialNameValue, setMaterialNameValue] = useState([]);
    const classes = useStyles();

    //Autocomplete
    const [materialObj, setMaterialObj] = useState('');
    const [materialText, setMaterialText] = useState('');
    const handleChangeMaterial = (event, newValue) => {
        setMaterialObj(newValue);
        setMaterialText(newValue ? newValue.materialCodeName : "");
        setmaterialValue(newValue ? newValue.materialId : 0);
        GetGroupCenter(wageValue, workCenterValue, newValue ? newValue.materialId : 0);
    };
    const handleChangeMaterialInput = (event, newInputValue) => {
        setMaterialText(newInputValue ? newInputValue : " ");
    };

    const [workCenterObj, setWorkCenterObj] = useState('');
    const [workCenterText, setWorkCenterText] = useState('');

    const handleChangeWorkCenter = (event, newValue) => {
        setWorkCenterObj(newValue);
        setWorkCenterText(newValue ? newValue.workCenterCodeName : "");
        setworkCenterValue(newValue ? newValue.workCenterId : 0);
        GetMaterial(wageValue, newValue ? newValue.workCenterId : 0, 0);
    };
    const handleChangeWorkCenterInput = (event, newInputValue) => {
        setWorkCenterText(newInputValue ? newInputValue : " ");
    };

    function clearState() {
        setOpen(false);
        setslipDetId(0);
        setwageValue("");
        setworkCenterValue("");
        setmaterialValue("");
        setgroupcenterValue("");
        setoperationValue("");
        setokpcs(0);
        setnotokpcs(0);
        setnoofsettings(0);
        setaddsetuptime(0);
        setextracost(0);
        setoutputmin(0);
        setlabourSetuptime(0);
        setmachineRuntime(0);
        setinputmin(0);
        setworkingMethodValue(1);
        setoperationSaveValue("");
        setoperationIdValue([]);
        setoperationNameValue([]);
        setbaseQuantity(0);
        setWorkCenterNameValue([]);
        setMaterialNameValue([]);
        setWorkCenterObj("");
        setWorkCenterText("");
        setMaterialObj("");
        setMaterialText("");
    }

    const handleRegistrationFormClickOpen = () => {
        clearState();
        setOpen(true);
        GetWages();
    };

    const handleRegistrationFormClickClose = () => {
        setOpen(false);
        props.clickgoback();
    };
    
    const handleChangeworkingMethod = (event) => {
        setworkingMethodValue(event.target.value);
    };

    const handleChangeWage = (event) => {
        setwageValue(event.target.value);
        if (event.target.value !== '0')
            GetWorkCenter(event.target.value, 0);
    };

    //const handleChangeWorkCenter = (event) => {
    //    setworkCenterValue(event.target.value);
    //    if (event.target.value !== '0' || event.target.value !== '')
    //        GetMaterial(wageValue, event.target.value);
    //};

    //const handleChangeMaterial = (event) => {
    //    setmaterialValue(event.target.value);
    //    if (event.target.value !== '0')
    //        GetGroupCenter(wageValue, workCenterValue, event.target.value);
    //};

    //const handleChangeWorkCenter_Autocomplete = (event, newValue) => {
    //    if (newValue != null) {
    //        setworkCenterValue(newValue.workCenterId);
    //        workCenter.filter(x => x.workCenterId == newValue.workCenterId).map(filtered => { setWorkCenterNameValue(filtered) });
    //        GetMaterial(wageValue, newValue.workCenterId);
    //    }
    //    else {
    //        setworkCenterValue("");
    //        setWorkCenterNameValue([]);
    //    }
    //};

    //const handleChangeMaterial_Autocomplete = (event, newValue) => {
    //    if (newValue != null) {
    //        setmaterialValue(newValue.materialId);
    //        material.filter(x => x.materialId == newValue.materialId).map(filtered => { setMaterialNameValue(filtered) });
    //        GetGroupCenter(wageValue, workCenterValue, newValue.materialId);
    //    }
    //    else {
    //        setmaterialValue("");
    //        setMaterialNameValue([]);
    //    }
    //};

    const handleChangeGroupCenter = (event) => {
        setgroupcenterValue(event.target.value);
        if (event.target.value !== '0')
            GetOperations(wageValue, workCenterValue, materialValue, event.target.value);
    };

    const handleChange = (event) => {
        setoperationNameValue(event.target.value);
    };
    
    function handleCheckedItem(val) {
        var arrOperationId = operationIdValue;   
        var arrSelOperationId = [];
        if (arrOperationId.indexOf(val) > -1) {
            for (let i = 0; i <= arrOperationId.length - 1; i++) {
                if (val !== arrOperationId[i]) {
                    arrSelOperationId.push(arrOperationId[i]);
                }
            }
        }
        else {
            for (let i = 0; i <= arrOperationId.length - 1; i++) {
                arrSelOperationId.push(arrOperationId[i]);
            }
            arrSelOperationId.push(val)
        }
        setoperationIdValue(arrSelOperationId);
        calculateRuntimeSetuptime(arrSelOperationId);
    };

    function calculateRuntimeSetuptime(arrSelOperationId) {
        let runtime = 0;
        let setuptime = 0;
        let operationValues = "";
        let sep = "";
        let baseqty = 0;
        for (let j = 0; j <= arrSelOperationId.length - 1; j++) {
            let oId = arrSelOperationId[j];
            let arr = operation.filter(x => x.operationId == oId);
            if (arr.length > 0) {
                for (let i = 0; i <= arr.length - 1; i++) {
                    if (Number(arr[i].baseQuantity) > 0) {
                        runtime = runtime + (Number(arr[i].machineRuntime) / Number(arr[i].baseQuantity));
                    }
                    else {
                        runtime = runtime + Number(arr[i].machineRuntime);
                    }
                    setuptime = setuptime + Number(arr[i].laboursetuptime);
                    baseqty = baseqty + Number(arr[i].baseQuantity);
                    operationValues = operationValues + sep + oId + "###" + arr[i].machineRuntime + "###" + arr[i].laboursetuptime + "###" + arr[i].baseQuantity;
                    sep = "#####";
                }
            }
        }
        setoperationSaveValue(operationValues);
        setmachineRuntime(runtime);
        setlabourSetuptime(setuptime);
        setbaseQuantity(baseqty);
        CalculateOutputMin_onOperationChange(runtime, setuptime)
    }

    function GetWages() {
        const headers = {
            Authorization: "Bearer " + bearerToken,
            UserEmail: userDetails.emailId,
            userId: uId,
            RoleName: userDetails.roleName,
            Gid: userDetails.gid,
            Roleid: userDetails.roleId,
            //AzureToken: token,
          };
        ////console.log(props.MrpcontrollerId);
        //let mrpcontrollerId = Number(props.MrpcontrollerId);
        //if (mrpcontrollerId > 0) {
        //    api.get('/getTblMstWageGroup/' + mrpcontrollerId)
        //        .then(res => {
        //            setwage(res.data);
        //        })
        //        .catch(error => {
        //            console.log("Error in hitting api at page load. : WageGroup")
        //        })
        //}  
        let mrpcontrollerId = Number(props.MrpcontrollerId);
        var CustomeSlip = {
            MrpcontrollerId: mrpcontrollerId,
        }
        api.post('/getTblMstWageGroup/', CustomeSlip,{
            headers: headers
        })
            .then(res => {
                setwage(res.data);
            })
            .catch(error => {
                console.log("Error in hitting api at page load : WageGroup")
            })
    }

    function GetWorkCenter(wageGroupId, workCenterId) {
        const headers = {
            Authorization: "Bearer " + bearerToken,
            UserEmail: userDetails.emailId,
            userId: uId,
            RoleName: userDetails.roleName,
            Gid: userDetails.gid,
            Roleid: userDetails.roleId,
            //AzureToken: token,
          };
        if (wageGroupId === undefined) {
            wageGroupId = wageValue;
        }
        var CustomeSlip = {
            MrpcontrollerId: props.MrpcontrollerId,
            WageGroupId: wageGroupId
        }
        api.post('/getWorkCenterByWageGroup/', CustomeSlip,{
            headers: headers
        })
            .then(res => {
                setworkCenter(res.data);
                if (workCenterId > 0) {
                    let workCenterData = [];
                    workCenterData = res.data;
                    if (workCenterData) {
                        workCenterData.filter(x => x.workCenterId == workCenterId).map(filtered => {
                            setWorkCenterObj(filtered);
                            setWorkCenterText(filtered.workCenterCodeName ? filtered.workCenterCodeName : "");
                        });
                    }                    
                }
            })
            .catch(error => {
                console.log("Error in hitting api at page load : WorkCenter")
            })
    }

    function GetMaterial(wageGroupId, workCenterId, materialId) {
        const headers = {
            Authorization: "Bearer " + bearerToken,
            UserEmail: userDetails.emailId,
            userId: uId,
            RoleName: userDetails.roleName,
            Gid: userDetails.gid,
            Roleid: userDetails.roleId,
            //AzureToken: token,
          };
        if (wageGroupId === undefined) {
            wageGroupId = wageValue;
        }
        if (workCenterId === undefined) {
            workCenterId = workCenterValue;
        }
        var CustomeSlip = {
            MrpcontrollerId: props.MrpcontrollerId,
            WageGroupId: wageGroupId,
            WorkCenterId: workCenterId
        }
        api.post('/getMaterialByWorkCenter/', CustomeSlip,{
            headers: headers
        })
            .then(res => {
                setmaterial(res.data);
                if (materialId > 0) {
                    let materialData = [];
                    materialData = res.data;
                    if (materialData) {
                        materialData.filter(x => x.materialId == materialId).map(filtered => {
                            setMaterialObj(filtered);
                            setMaterialText(filtered.materialCodeName ? filtered.materialCodeName : 0);
                        });
                    }                    
                }                
            })
            .catch(error => {
                console.log("Error in hitting api at page load : material")
            })
    }

    function GetGroupCenter(wageGroupId, workCenterId, materialId) {
        const headers = {
            Authorization: "Bearer " + bearerToken,
            UserEmail: userDetails.emailId,
            userId: uId,
            RoleName: userDetails.roleName,
            Gid: userDetails.gid,
            Roleid: userDetails.roleId,
            //AzureToken: token,
          };
        if (wageGroupId === undefined) {
            wageGroupId = wageValue;
        }
        if (workCenterId === undefined) {
            workCenterId = workCenterValue;
        }
        if (materialId === undefined) {
            materialId = materialValue;
        }
        
        var CustomeSlip = {
            MrpcontrollerId: props.MrpcontrollerId,
            WageGroupId: wageGroupId,
            WorkCenterId: workCenterId,
            MaterialId: materialId
        }
        api.post('/getGroupCenterByMaterial/', CustomeSlip,{
            headers: headers
        })
            .then(res => {
                setgroupcenter(res.data);
            })
            .catch(error => {
                console.log("Error in hitting api at page load : group center")
            })
    }

    function GetOperations(wageGroupId, workCenterId, materialId, grcId) {
        const headers = {
            Authorization: "Bearer " + bearerToken,
            UserEmail: userDetails.emailId,
            userId: uId,
            RoleName: userDetails.roleName,
            Gid: userDetails.gid,
            Roleid: userDetails.roleId,
            //AzureToken: token,
          };
        if (wageGroupId === undefined) {
            wageGroupId = wageValue;
        }
        if (workCenterId === undefined) {
            workCenterId = workCenterValue;
        }
        if (materialId === undefined) {
            materialId = materialValue;
        }
        if (grcId === undefined) {
            grcId = groupcenterValue;
        }
        var CustomeSlip = {
            MrpcontrollerId: props.MrpcontrollerId,
            WageGroupId: wageGroupId,
            WorkCenterId: workCenterId,
            MaterialId: materialId,
            GrcId:grcId
        }
        api.post('/getOperationsByGroupCenter/', CustomeSlip,{
            headers: headers
        })
            .then(res => {
                setoperation(res.data);
            })
            .catch(error => {
                console.log("Error in hitting api at page load : operations")
            })
    }

    function GetWorkingMethod() {
        const headers = {
            Authorization: "Bearer " + bearerToken,
            UserEmail: userDetails.emailId,
            userId: uId,
            RoleName: userDetails.roleName,
            Gid: userDetails.gid,
            Roleid: userDetails.roleId,
            //AzureToken: token,
          };
        api.get('/getTblMstWorkingMethod/',{
            headers: headers
        })
            .then(res => {
                setworkingMethod(res.data);
            })
            .catch(error => {
                console.log("Error in hitting api at page load : Working Method")
            })
    }

    const handleChangeOkPcs = (event) => {
        setokpcs(event.target.value);
        CalculateOutputMin(1, event.target.value);
    };

    const handleChangeNotOkPcs = (event) => {
        setnotokpcs(event.target.value);
        CalculateOutputMin(2, event.target.value);
    };

    const handleChangeNoofSettings = (event) => {
        setnoofsettings(event.target.value);
        CalculateOutputMin(3, event.target.value);
    };

    const handleChangeAddSetupTime = (event) => {
        setaddsetuptime(event.target.value);
        CalculateOutputMin(4, event.target.value);
    };

    const handleChangeExtraCost = (event) => {
        setextracost(event.target.value);
        CalculateOutputMin(5, event.target.value);
    };

    const handleChangeInputMins = (event) => {
        setinputmin(event.target.value);
    };

    function CalculateOutputMin(type, val) {
        //Formula [(OKP + NOKP) * runtime] + [No of Setting * SetupTime] + Add SetupTime + Extra Cost
        let Okpcs = okpcs;
        let Notokpcs = notokpcs;
        let Noofsettings = noofsettings;
        let Addsetuptime = addsetuptime;
        let Extracost = extracost;

        if (type === 1)
            Okpcs = val;
        if (type === 2)
            Notokpcs = val;
        if (type === 3)
            Noofsettings = val;
        if (type === 4)
            Addsetuptime = val;
        if (type === 5)
            Extracost = val;

        let OutputMin = ((Number(Okpcs) + Number(Notokpcs)) * Number(machineRuntime)) + (Number(Noofsettings) * Number(labourSetuptime)) + Number(Addsetuptime) + Number(Extracost);

        setoutputmin(OutputMin);
    }

    function CalculateOutputMin_onOperationChange(machineRuntimeVal, labourSetuptimeVal) {
        //Formula [(OKP + NOKP) * runtime] + [No of Setting * SetupTime] + Add SetupTime + Extra Cost
        let Okpcs = okpcs;
        let Notokpcs = notokpcs;
        let Noofsettings = noofsettings;
        let Addsetuptime = addsetuptime;
        let Extracost = extracost;

        
        let OutputMin = ((Number(Okpcs) + Number(Notokpcs)) * Number(machineRuntimeVal)) + (Number(Noofsettings) * Number(labourSetuptimeVal)) + Number(Addsetuptime) + Number(Extracost);

        setoutputmin(OutputMin);
    }

    function setState_FetchData(rowData) {  
        //console.log(rowData);
        setslipDetId(rowData.slipGenDetId);
        setwageValue(rowData.wageGroupId);
        setworkCenterValue(rowData.workCenterId);
        setmaterialValue(rowData.materialId);
        setgroupcenterValue(rowData.groupCid);
        setoperationValue(rowData.operationId);
        setokpcs(rowData.noOfOkpiece);
        setnotokpcs(rowData.noOfNotOkpiece);
        setnoofsettings(rowData.noOfSettings);
        setaddsetuptime(rowData.addSetUpTime);
        setextracost(rowData.extraCost);
        setoutputmin(rowData.outputMins);
        setlabourSetuptime(rowData.labourSetuptime);
        setmachineRuntime(rowData.machineRuntime);
        setinputmin(rowData.inputMin);
        setworkingMethodValue(rowData.workingMethodId);
        setArrayValue(rowData.operation, 1);
        setArrayValue(rowData.operationName, 2);
        setoperationSaveValue(rowData.operationSaveValue);
        setbaseQuantity(rowData.baseQuantity);        
    }

    function setArrayValue(operation, type) {
        if (type === 1) {
            let arr = [];
            if (operation !== null)
                arr = operation.split(',');

            let arrId = [];
            for (let i = 0; i <= arr.length - 1; i++) {
                if (Number(arr[i]) > 0)
                arrId.push(Number(arr[i]));
            }
            setoperationIdValue(arrId);
        }
        else {
            let arr = [];
            if (operation !== null)
                arr = operation.split('#####');

            let arrName = [];
            for (let i = 0; i <= arr.length - 1; i++) {
                if (arr[i] !== "")
                    arrName.push(arr[i]);
            }
            setoperationNameValue(arrName);
        }
    }

    function SaveSlipDetails() {
        const headers = {
            Authorization: "Bearer " + bearerToken,
            UserEmail: userDetails.emailId,
            userId: uId,
            RoleName: userDetails.roleName,
            Gid: userDetails.gid,
            Roleid: userDetails.roleId,
            //AzureToken: token,
          };
        let slipDet = {
            Id: Number(slipDetId),
            SlipGenId: Number(props.SlipGenId),
            WageGroupId: Number(wageValue),
            WorkCenterId: Number(workCenterValue),
            MaterialId: Number(materialValue),
            GroupCid: Number(groupcenterValue),
            WorkingMethodId: Number(workingMethodValue),
            NoOfOkpiece: parseFloat(okpcs),
            NoOfNotOkpiece: parseFloat(notokpcs),
            NoOfSettings: parseFloat(noofsettings),
            AddSetUpTime: parseFloat(addsetuptime),
            ExtraCost: parseFloat(extracost),
            InputMin: parseFloat(inputmin),
            OutputMins: parseFloat(outputmin),
            MachineRuntime: parseFloat(machineRuntime),
            LabourSetuptime: parseFloat(labourSetuptime),
            baseQuantity: baseQuantity,
            CreatedBy: props.loginuser.response.employeeId,
            ModifiedBy: props.loginuser.response.employeeId,
            slipGenOperationDetails:operationSaveValue
        }
        setopenLoader(true);
        apiSlip.post("/SaveSlipGenDetails/", slipDet,{
            headers: headers
        })
            .then(res => {
                setopenLoader(false);
                props.getDataOnSubmit(res.data);
                handleRegistrationFormClickClose();
            })
            .catch(error => {
                setopenLoader(false);
                console.log(error);
            })
    }

    useEffect(() => {
        GetWages();
        if (props.isDialogOpen) {
            //setopenLoader(true);
            setOpen(props.isDialogOpen);
            GetWorkCenter(props.editData.wageGroupId, props.editData.workCenterId);
            GetMaterial(props.editData.wageGroupId, props.editData.workCenterId, props.editData.materialId);
            GetGroupCenter(props.editData.wageGroupId, props.editData.workCenterId, props.editData.materialId);
            GetOperations(props.editData.wageGroupId, props.editData.workCenterId, props.editData.materialId, props.editData.groupCid);
            setState_FetchData(props.editData);
            //setopenLoader(false);
        }
        GetWorkingMethod();
    }, [props.isDialogOpen, props.editData]);

    return (
        <ThemeProvider theme={lightTheme}>
            <Button className="besys-button--hero besys-button--register" disabled={props.isDisabled} onClick={handleRegistrationFormClickOpen}>
                Add
            </Button>
            <Dialog
                onClose={handleRegistrationFormClickClose}
                aria-labelledby="data-form"
                open={open}
                maxWidth={"md"}
            >
                <DialogTitle className="clr-000028" id="data-form" onClose={handleRegistrationFormClickClose}>
                    Add New Data
                </DialogTitle>
                <DialogContent>
                    <form className={classes.root} noValidate autoComplete="off">
                        <Grid container spacing={2}>
                            <Grid item xs={12} sm={4}>
                                <FormControl variant="filled" className="reg-form--division-icon" fullWidth>
                                    <InputLabel id="selectDropdownDefault-label">Wage Group</InputLabel>
                                    <Select
                                        labelId="selectDropdownDefault-label"
                                        id="selectDropdownDefault"
                                        value={wageValue}
                                        onChange={handleChangeWage}
                                    >
                                        <MenuItem value="0">
                                            <em>Select</em>
                                        </MenuItem>
                                        {
                                            wage.map((item) =>
                                                (<MenuItem key={item.wageGroupId} value={item.wageGroupId}>{item.wageGroup}</MenuItem>))
                                        }
                                    </Select>
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} sm={4}>                                
                                <Autocomplete
                                    className="lightInputFields"
                                    id="Autocomplete_workcenter"
                                    fullWidth
                                    value={workCenterObj}
                                    inputValue={workCenterText}
                                    options={workCenter}
                                    getOptionLabel={option => option.workCenterCodeName ? option.workCenterCodeName : ""}
                                    onChange={handleChangeWorkCenter}
                                    onInputChange={handleChangeWorkCenterInput}
                                    renderInput={
                                        (params) =>
                                            <TextField {...params}
                                                label="Work Center"
                                            />
                                    }
                                />
                            </Grid>
                            <Grid item xs={12} sm={4}>                               
                                <Autocomplete
                                    className="lightInputFields"
                                    id="Autocomplete_material"
                                    fullWidth
                                    value={materialObj}
                                    inputValue={materialText}
                                    options={material}
                                    getOptionLabel={option => option.materialCodeName ? option.materialCodeName : ""}
                                    onChange={handleChangeMaterial}
                                    onInputChange={handleChangeMaterialInput}
                                    renderInput={
                                        (params) =>
                                            <TextField {...params}
                                                label="Material"
                                            />
                                    }
                                />
                            </Grid>
                            <Grid item xs={12} sm={4}>
                                <FormControl variant="filled" className="reg-form--division-icon" fullWidth>
                                    <InputLabel id="selectDropdownDefault-label">GrC</InputLabel>
                                    <Select
                                        labelId="selectDropdownDefault-label"
                                        id="selectDropdownDefault"
                                        value={groupcenterValue}
                                        onChange={handleChangeGroupCenter}
                                    >
                                        <MenuItem value="0">
                                            <em>Select</em>
                                        </MenuItem>
                                        {
                                            groupcenter.map((item) =>
                                                (<MenuItem key={item.grcId} value={item.grcId}>{item.grcCode}-{item.grcDescription}</MenuItem>))
                                        }
                                    </Select>
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} sm={4}>
                                <FormControl variant="filled" className="reg-form--division-icon width-100 multi-select">
                                    <InputLabel id="demo-mutiple-checkbox-label">Operations</InputLabel>
                                    <Select
                                        labelId="demo-mutiple-checkbox-label"
                                        id="demo-mutiple-checkbox"
                                        multiple
                                        value={operationNameValue}
                                        onChange={handleChange}
                                        input={<Input />}
                                        renderValue={(selected) => selected.join(', ')}
                                    >
                                        {operation.map((item) => (
                                            <MenuItem key={item.value} value={item.label} onClick={() => handleCheckedItem(item.value)}>
                                                <Checkbox checked={operationNameValue.indexOf(item.label) > -1} />
                                                <ListItemText primary={item.label} />
                                            </MenuItem>
                                        ))}
                                    </Select>
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} sm={4}>
                                <TextField id="ok_pcs" value={okpcs} onChange={handleChangeOkPcs} fullWidth label="OK PCs" variant="filled"  />
                            </Grid>
                            <Grid item xs={12} sm={4}>
                                <TextField id="nok_pcs" value={notokpcs} onChange={handleChangeNotOkPcs} fullWidth label="NOK PCs" variant="filled" />
                            </Grid>
                            <Grid item xs={12} sm={4}>
                                <TextField id="no_of_settings" value={noofsettings} onChange={handleChangeNoofSettings} fullWidth label="No Of Settings" variant="filled" />
                            </Grid>
                            <Grid item xs={12} sm={4}>
                                <TextField id="add_setup_time" value={addsetuptime} onChange={handleChangeAddSetupTime} fullWidth label="Add Setup Time" variant="filled" />
                            </Grid>
                            <Grid item xs={12} sm={4}>
                                <TextField id="extra_cost" value={extracost} fullWidth onChange={handleChangeExtraCost} label="Extra Cost" variant="filled" />
                            </Grid>
                            <Grid item xs={12} sm={4}>
                                <TextField id="input_mins" value={inputmin} fullWidth onChange={handleChangeInputMins} label="Input Mins" variant="filled" />
                            </Grid>
                            <Grid item xs={12} sm={4}>
                                <FormControl variant="filled" className="reg-form--division-icon" fullWidth>
                                        <InputLabel id="selectDropdownDefault-label">Working Method</InputLabel>
                                        <Select
                                            labelId="selectDropdownDefault-label"
                                            id="selectDropdownDefault"
                                            value={workingMethodValue}
                                            onChange={handleChangeworkingMethod}
                                        >
                                        <MenuItem value="">
                                            <em>Select</em>
                                        </MenuItem>
                                        {
                                            workingMethod.map((item) =>
                                                (<MenuItem key={item.workingMethodId} value={item.workingMethodId}>{item.workingMethod}</MenuItem>))
                                        }
                                        </Select>
                                    </FormControl>
                            </Grid>
                            <Grid item xs={12} sm={4}>
                                <TextField id="output_mins" value={outputmin} fullWidth label="Output Mins" variant="filled" disabled="true" />
                            </Grid>
                            <Grid item xs={12} sm={4}>
                                <TextField id="machineRuntime" value={machineRuntime} fullWidth label="Machine Runtime" variant="filled" disabled="true" />
                            </Grid>
                            <Grid item xs={12} sm={4}>
                                <TextField id="labourSetuptime" value={labourSetuptime} fullWidth label="Labour Setuptime" variant="filled" disabled="true" />
                            </Grid>
                        </Grid>
                    </form>
                </DialogContent>
                <DialogActions>
                    <Grid container>
                        <Grid item xs={5}>
                            <Button className="e-performance-button--tertiary" onClick={handleRegistrationFormClickClose}>
                                &lt; Go Back
                            </Button>
                        </Grid>
                        <Grid item xs={7} className="d-flex">
                            <Button className="e-performance-button--primary width-25 f-20" onClick={SaveSlipDetails}>
                            Save
                            </Button>
                        </Grid>
                    </Grid>
                    <Dialog
                        open={openLoader}
                        //onClose={handleClose}
                        aria-labelledby="draggable-dialog-title"
                        id="templateUploadSuccess"
                        PaperProps={{
                            style: {
                                backgroundColor: "transparent",
                                boxShadow: "none",
                                borderColor: "transparent"
                            },
                        }}>
                        <DialogContent>
                            <CircularProgress />
                        </DialogContent>
                    </Dialog>
                </DialogActions>
            </Dialog>
        </ThemeProvider>
    );
}


